<template>
  <div>
    <time-line v-model="collapseValue"  :dataArr="flowData" :selfUserId="selfUserId"  />
  </div>
</template>

<script>
import timeLine from './template/timeLine.vue';
export default {
  components: { timeLine },
  data () {
    return {
      collapseValue: []
    };
  },
  props: {
    detailData: {
      type: Object,
      default: {}
    },
    selfUserId: String // 当前用户id
  },
  computed: {
    flowData() {
      return this.detailData.flowList || [];
    }
  },
  watch: {
    'detailData.flowList': {
      handler(val) {
        let id = '';
        this.collapseValue = [];
        if (val && val instanceof Array && val.length > 0) {
          id = val[val.length - 1].instApplyFlowId;
        };
        // 默认展开
        this.collapseValue.push(id);
      },
      deep: true
    }
  }
};
</script>

<style>

</style>
